<template>
  <iframe
      :src="`https://springmedia.go2cloud.org/aff_l?offer_id=3877&adv_sub=${uuid}&amount=${amount}`"
      scrolling="no"
      frameborder="0"
      width="1"
      height="1"
    ></iframe>
</template>

<script>

export default {
  name: 'YboxIframe',
  props: ['amount', 'uuid']
}
</script>

<style scoped>

</style>
